<svg xmlns="http://www.w3.org/2000/svg"  width="100%" height="100%" viewBox="0 0 300 320" [ngClass]="{'border': border}">
  <g class="pieGraph" >
    @if (multiple) {
      <ng-container>
        @for (circ of list; track circ; let i = $index) {
          <circle
            class="line multiple"
            [ngClass]="circ.type" cx="150" cy="150" r="120"
            [attr.stroke-dasharray]="getlineSpace(circ.value, i)"
            [attr.transform]="checkRotation(i)"
            (mouseover)='showItem(i)'
            (mouseleave)='startGraph()'>
          </circle>
        }
      </ng-container>
    }
    @if (!multiple) {
      <ng-container>
        @for (circ of list; track circ; let i = $index) {
          <circle
            class="line"
            [ngClass]="circ.type" cx="150" cy="150" r="120"
            [attr.stroke-dasharray]="getlineSpace(circ.value)"
            [attr.transform]="checkRotation(i)"
            (mouseover)='showItem(i)'
            (mouseleave)='startGraph()'>
          </circle>
        }
      </ng-container>
    }
    <circle class="center" [ngClass]="selectedValue.type" cx="150" cy="150" r="100">
    </circle>
    @if (valueType == 'Number') {
      <g>
        <text class="total" [ngClass]="selectedValue.type" x="150" y="160">
          @if (selectedValue.value < 1000 && !multiple) {
            <tspan >{{selectedValue.value}}</tspan>
          }
          @if (multiple) {
            <tspan >{{selectedValue.value}}</tspan>
          }
        </text>
        <text class="label" [ngClass]="selectedValue.type" x="150" y="190">{{selectedValue.name | translate}}</text>
        <text class="subtotal" [ngClass]="selectedValue.type" x="150" y="230">
          <tspan>{{total}}</tspan>
        </text>
      </g>
    }
    @if (valueType == 'pages') {
      <g>
        <text class="total" [ngClass]="selectedValue.type" x="150" y="160">
          @if (selectedValue.value || selectedValue.value == 0) {
            <tspan [innerHTML]="selectedValue.value | pageCount: false: 'whole'"></tspan>
          }
          <tspan>&nbsp;</tspan>
          @if (selectedValue.value || selectedValue.value == 0) {
            <tspan class="fraction" [innerHTML]="(selectedValue.value | pageCount: false: 'fraction')" dy="-15"></tspan>
          }
        </text>
        <text class="label" [ngClass]="selectedValue.type" x="150" y="190">{{selectedValue.name | translate}}</text>
        <text class="subtotal" [ngClass]="selectedValue.type" x="150" y="230">
          @if (total || total == 0) {
            <tspan [innerHTML]="total | pageCount: false: 'whole'"></tspan>
          }
          <tspan>&nbsp;</tspan>
          @if (total || total == 0) {
            <tspan class="fraction" [innerHTML]="(total | pageCount: false: 'fraction')" dy="-10"></tspan>
          }
        </text>
      </g>
    }
    <!-- class="percent">{{getSegValue(value)}} -->
    @if (valueType == 'minutes') {
      <g>
        <text class="total" [ngClass]="selectedValue.type" x="150" y="160">
          @if (selectedValue.value < 1000 && !multiple) {
            <tspan >{{getTimeValue(selectedValue.value)}}</tspan>
          }
          @if (multiple) {
            <tspan >{{getTimeValue(selectedValue.value)}}</tspan>
          }
        </text>
        <text class="label" [ngClass]="selectedValue.type" x="150" y="190">{{selectedValue.name | translate}}</text>
        <text class="subtotal" [ngClass]="selectedValue.type" x="150" y="230">
          <tspan>{{getTimeValue(total)}}</tspan>
        </text>
      </g>
    }

    @if (tittle) {
      <text class="tittle" [ngClass]="selectedValue.type" x="150" y="310">{{tittle}}</text>
    }
  </g>
</svg>